import { Location } from '@app/shared/routes';

const RootLocation = new Location({ path: '/' });

export { RootLocation };
